var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReservationCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_211_1487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7448 16.744C20.4694 13.0194 20.4694 6.98059 16.7448 3.25597C13.0202 -0.468661 6.98136 -0.468661 3.25673 3.25597C-0.4679 6.9806 -0.467894 13.0194 3.25673 16.744C6.98136 20.4687 13.0202 20.4687 16.7448 16.744Z",
    fill: "#1CA362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.22168 10.0498L8.59682 12.4249",
    stroke: "#F2F2F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7772 7.46875L8.7168 12.5304",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_211_1487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservationCompleted);
export default __webpack_public_path__ + "static/media/reservation-completed.2e83a975a99893d445b9d710138946f0.svg";
export { ForwardRef as ReactComponent };